// extracted by mini-css-extract-plugin
export default {"title":"Title_title__-ywmb","xl":"Title_xl__RkeR+","l":"Title_l__cz1A1","m":"Title_m__B88RA","s":"Title_s__Eixcw","xs":"Title_xs__OM7wI"};